import { useEffect, useRef } from 'react';

import { ReactEditor, useSlate } from 'slate-react';

import { cn } from '@/shadcn/lib/utils';

import { MySuperBadPortal } from '@/components/ui/richEditor/richEditor.portal';

type Props = {
  users: any[];
  index: number;
  search: string;
  target?: any;
};

export const UserList = ({ users, index, search, target = null }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const editor = useSlate();

  useEffect(() => {
    if (target && users?.length > 0 && ref.current) {
      const el = ref.current;
      const domRange = ReactEditor.toDOMRange(editor, target);
      const rect = domRange.getBoundingClientRect();
      el.style.top = `${rect.top + window.pageYOffset + 24}px`;
      el.style.left = `${rect.left + window.pageXOffset}px`;
    }
  }, [users?.length, editor, index, search, target]);

  if (!target || users?.length === 0) return null;

  return (
    <MySuperBadPortal>
      <div
        className="-top-2000 -left-2000 absolute z-2 rounded-md border border-border bg-popover p-1 text-popover-foreground text-sm"
        ref={ref}
      >
        {users?.map((user, i) => (
          <div
            className={cn(
              'rounded-sm bg-transparent px-1 py-px',
              i === index && 'bg-accent text-accent-foreground'
            )}
            key={user.id}
          >
            {user.name}
          </div>
        ))}
      </div>
    </MySuperBadPortal>
  );
};

UserList.displayName = 'UserList';
